import { useEffect, useState } from "react";
import { fetchJson } from "../../helpers";
import FormPreviewModal from "./FormPreviewModal";

export default function FormPreviewModalWrapper({linkTitleHtml, modalTitle, formFetchPath, formData=null, formAnswers=null}) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(null);
  const [answers, setAnswers] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!showModal) return;

    setLoading(true);
    if(!formData || !formAnswers){
      fetchJson(formFetchPath, {method: 'POST'})
        .then((res) => {
          setForm(formData ? formData : res.form);
          setAnswers(formAnswers ? formAnswers : res.answers);
          setLoading(false);
        }
      );
    } else {
      setForm(formData);
      setAnswers(formAnswers);
      setLoading(false);
    }
  }, [showModal]);

  const handleClick = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <>
        <a href="#"
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
        dangerouslySetInnerHTML={{ __html: linkTitleHtml }}
      />

      {showModal && (<FormPreviewModal
        loading={loading}
        modalTitle={modalTitle}
        form={form}
        answers={answers}
        onClose={() => setShowModal(false)}
      />)}
    </>
  );
}